import { P2GCard } from '@parcel2go/core-ui';

interface AppCardProps {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  variant?: 'info' | 'warning' | 'error' | 'success' | 'primary' | 'secondary';
}

export const AppCard = ({ variant, children, className, disabled }: AppCardProps) => {
  return (
    <P2GCard
      sx={(t) => ({
        boxShadow: `0 0 10px 5px ${t.palette.grey.A200}`,
        borderRadius: t.spacing(2),
        backgroundColor: 'white',
        overflow: 'visible',
        padding: 0,
        opacity: disabled ? 0.3 : 1,
        transition: 'all 0.2s ease-in-out',
        outline: variant ? `3px solid ${t.palette[variant].main}` : undefined,
        height: '100%'
      })}
      classNames={[
        className,
        'p2g-app-card',
        disabled && 'p2g-app-card-disabled',
        variant && `p2g-app-card-${variant}`
      ]}
    >
      {children}
    </P2GCard>
  );
};
